import { useEffect } from 'react';

const APP_NAME = 'TradeDigger';

/**
 * Sets the document.title for the current page. Pass an empty string or
 * undefined to fall back to the bare app name.
 *
 * Usage: useDocumentTitle('Job monitoring');
 *   → "Job monitoring · TradeDigger"
 */
export function useDocumentTitle(title?: string): void {
    useEffect(() => {
        const previous = document.title;
        document.title = title && title.trim().length > 0
            ? `${title} · ${APP_NAME}`
            : APP_NAME;
        return () => {
            document.title = previous;
        };
    }, [title]);
}
